const integrityTest = {
  id: 'integrity',
  name: 'Integrity SQL Trainer',
  subtitle: 'Mock interview · Data Engineer loop',
  description: 'Policy violation tracking and enforcement analysis',
  pinnedNow: '2026-04-10 12:00:00',

  schema: `
    CREATE TABLE conversations (
      conversation_id TEXT PRIMARY KEY,
      user_id TEXT,
      started_at TEXT,
      ended_at TEXT,
      surface TEXT,
      model TEXT
    );

    CREATE TABLE messages (
      message_id TEXT PRIMARY KEY,
      conversation_id TEXT,
      role TEXT,
      created_at TEXT,
      token_count INTEGER,
      FOREIGN KEY (conversation_id) REFERENCES conversations(conversation_id)
    );

    CREATE TABLE policy_violations (
      violation_id TEXT PRIMARY KEY,
      message_id TEXT,
      policy_category TEXT,
      severity INTEGER,
      detected_at TEXT,
      detector_version TEXT,
      FOREIGN KEY (message_id) REFERENCES messages(message_id)
    );

    CREATE TABLE enforcement_actions (
      action_id TEXT PRIMARY KEY,
      user_id TEXT,
      action_type TEXT,
      created_at TEXT,
      triggering_violation_id TEXT,
      FOREIGN KEY (triggering_violation_id) REFERENCES policy_violations(violation_id)
    );
  `,

  seedDataFn: (db) => {
    // Conversations
    const conversations = [
      ['c1','u1','2026-01-19 10:00','2026-01-19 10:30','claude_ai','claude-opus-4-6'],
      ['c2','u1','2026-02-09 14:00','2026-02-09 14:20','api','claude-opus-4-6'],
      ['c3','u1','2026-03-02 09:00','2026-03-02 09:40','api','claude-opus-4-6'],
      ['c4','u1','2026-04-05 11:00','2026-04-05 11:20','api','claude-opus-4-6'],
      ['c5','u1','2026-04-07 16:00','2026-04-07 16:10','api','claude-opus-4-6'],
      ['c6','u2','2026-02-16 08:00','2026-02-16 08:30','claude_ai','claude-opus-4-6'],
      ['c7','u2','2026-03-16 12:00','2026-03-16 12:20','claude_ai','claude-opus-4-6'],
      ['c8','u2','2026-04-06 15:00','2026-04-06 15:20','claude_ai','claude-opus-4-6'],
      ['c9','u3','2026-03-01 10:00','2026-03-01 10:15','claude_ai','claude-opus-4-6'],
      ['c10','u3','2026-03-10 11:00','2026-03-10 11:15','claude_ai','claude-opus-4-6'],
      ['c11','u3','2026-04-08 09:00','2026-04-08 09:20','claude_ai','claude-opus-4-6'],
      ['c12','u4','2026-04-09 13:00','2026-04-09 13:10','api','claude-opus-4-6'],
      ['c13','u5','2026-01-26 10:00','2026-01-26 10:10','claude_ai','claude-opus-4-6'],
      ['c14','u5','2026-02-23 10:00','2026-02-23 10:10','claude_ai','claude-opus-4-6'],
      ['c15','u5','2026-03-23 10:00','2026-03-23 10:10','claude_ai','claude-opus-4-6'],
      ['c16','u5','2026-04-01 10:00','2026-04-01 10:10','claude_ai','claude-opus-4-6'],
      ['c17','u6','2026-02-10 10:00','2026-02-10 10:10','claude_ai','claude-opus-4-6'],
      ['c18','u6','2026-02-11 10:00','2026-02-11 10:10','claude_ai','claude-opus-4-6'],
      ['c19','u7','2025-11-15 10:00','2025-11-15 10:10','api','claude-opus-4-6'],
      ['c20','u7','2025-11-20 10:00','2025-11-20 10:10','api','claude-opus-4-6'],
      ['c21','u8','2025-12-01 10:00','2025-12-01 10:10','claude_ai','claude-opus-4-6'],
      ['c22','u8','2025-12-12 10:00','2025-12-12 10:10','claude_ai','claude-opus-4-6'],
      ['c23','u9','2025-12-15 10:00','2025-12-15 10:10','api','claude-opus-4-6'],
      ['c24','u9','2026-02-01 10:00','2026-02-01 10:10','api','claude-opus-4-6'],
      ['c25','u9','2026-02-05 10:00','2026-02-05 10:10','api','claude-opus-4-6'],
      ['c26','u10','2026-01-10 10:00','2026-01-10 10:10','api','claude-opus-4-6'],
      ['c27','u10','2026-01-12 10:00','2026-01-12 10:10','api','claude-opus-4-6'],
      ['c28','u10','2026-01-15 10:00','2026-01-15 10:10','api','claude-opus-4-6'],
      ['c29','u10','2026-01-20 10:00','2026-01-20 10:10','api','claude-opus-4-6'],
      // Additional conversations for low-severity violations in last 7 days
      ['c30','u11','2026-04-05 10:00','2026-04-05 10:10','claude_ai','claude-opus-4-6'],
      ['c31','u11','2026-04-06 11:00','2026-04-06 11:10','claude_ai','claude-opus-4-6'],
      ['c32','u12','2026-04-07 14:00','2026-04-07 14:10','api','claude-opus-4-6'],
      ['c33','u13','2026-04-08 16:00','2026-04-08 16:10','api','claude-opus-4-6'],
      ['c34','u13','2026-04-09 09:00','2026-04-09 09:10','api','claude-opus-4-6']
    ];

    const convStmt = db.prepare(
      'INSERT INTO conversations (conversation_id, user_id, started_at, ended_at, surface, model) VALUES (?, ?, ?, ?, ?, ?)'
    );
    conversations.forEach(c => convStmt.run(c));
    convStmt.free();

    // Messages
    const messages = [
      ['m1','c1','user','2026-01-19 10:05',120],
      ['m2','c2','user','2026-02-09 14:05',200],
      ['m3','c3','user','2026-03-02 09:10',150],
      ['m4','c4','user','2026-04-05 11:05',180],
      ['m5','c5','user','2026-04-07 16:02',90],
      ['m6','c6','user','2026-02-16 08:10',110],
      ['m7','c7','user','2026-03-16 12:05',130],
      ['m8','c8','user','2026-04-06 15:05',140],
      ['m9','c9','user','2026-03-01 10:05',90],
      ['m10','c10','user','2026-03-10 11:05',100],
      ['m11','c11','user','2026-04-08 09:05',100],
      ['m12','c12','user','2026-04-09 13:05',85],
      ['m13','c13','user','2026-01-26 10:05',70],
      ['m14','c14','user','2026-02-23 10:05',70],
      ['m15','c15','user','2026-03-23 10:05',70],
      ['m16','c16','user','2026-04-01 10:05',70],
      ['m17','c17','user','2026-02-10 10:05',70],
      ['m18','c18','user','2026-02-11 10:05',70],
      ['m19','c19','user','2025-11-15 10:05',70],
      ['m20','c20','user','2025-11-20 10:05',70],
      ['m21','c21','user','2025-12-01 10:05',70],
      ['m22','c22','user','2025-12-12 10:05',70],
      ['m23','c23','user','2025-12-15 10:05',70],
      ['m24','c24','user','2026-02-01 10:05',70],
      ['m25','c25','user','2026-02-05 10:05',70],
      ['m26','c26','user','2026-01-10 10:05',70],
      ['m27','c27','user','2026-01-12 10:05',70],
      ['m28','c28','user','2026-01-15 10:05',70],
      ['m29','c29','user','2026-01-20 10:05',70],
      // Additional messages for low-severity violations
      ['m30','c30','user','2026-04-05 10:05',80],
      ['m31','c31','user','2026-04-06 11:05',75],
      ['m32','c32','user','2026-04-07 14:05',90],
      ['m33','c33','user','2026-04-08 16:05',85],
      ['m34','c34','user','2026-04-09 09:05',95]
    ];

    const msgStmt = db.prepare(
      'INSERT INTO messages (message_id, conversation_id, role, created_at, token_count) VALUES (?, ?, ?, ?, ?)'
    );
    messages.forEach(m => msgStmt.run(m));
    msgStmt.free();

    // Policy Violations (carefully designed for question validation)
    const violations = [
      // u1 - 90d window: cyber(Jan sev4), cbrn(Feb sev3), harassment(Mar sev2), cbrn(Mar sev3), cyber(Apr sev5), cbrn(Apr sev4)
      ['v1-1','m1','cyber',4,'2026-01-19 10:06','d1'],
      ['v1-2','m2','cbrn',3,'2026-02-09 14:06','d1'],
      ['v1-3','m3','harassment',2,'2026-03-02 09:11','d1'],
      ['v1-4','m3','cbrn',3,'2026-03-02 09:12','d1'],
      ['v1-5','m4','cyber',5,'2026-04-05 11:06','d2'],  // Q1: last 7d, sev5
      ['v1-6','m5','cbrn',4,'2026-04-07 16:03','d2'],   // Q1: last 7d, sev4

      // u2 - 90d window: cyber sev4 (Feb, Mar, Apr) = 3 distinct weeks
      ['v2-1','m6','cyber',4,'2026-02-16 08:11','d1'],
      ['v2-2','m7','cyber',4,'2026-03-16 12:06','d1'],
      ['v2-3','m8','cyber',4,'2026-04-06 15:06','d2'],  // Q1: last 7d

      // u3 - harassment sev3 (Mar 1, Mar 10, Apr 8)
      ['v3-1','m9','harassment',3,'2026-03-01 10:06','d1'],
      ['v3-2','m10','harassment',3,'2026-03-10 11:06','d1'],
      ['v3-3','m11','harassment',4,'2026-04-08 09:06','d2'],  // Q1: last 7d

      // u4 - cyber sev5 (last 7d only)
      ['v4-1','m12','cyber',5,'2026-04-09 13:06','d2'],  // Q1: last 7d

      // u5 - 4 weeks but all severity 2 (excluded from Q2)
      ['v5-1','m13','cyber',2,'2026-01-26 10:06','d1'],
      ['v5-2','m14','cyber',2,'2026-02-23 10:06','d1'],
      ['v5-3','m15','cyber',2,'2026-03-23 10:06','d1'],
      ['v5-4','m16','cyber',2,'2026-04-01 10:06','d1'],

      // u6 - only 1 week (excluded from Q2)
      ['v6-1','m17','cyber',4,'2026-02-10 10:06','d1'],
      ['v6-2','m18','cyber',4,'2026-02-11 10:06','d1'],

      // u7 - warning in Nov, reoffence 5 days later (Q3)
      ['v7-1','m19','cyber',4,'2025-11-15 10:06','d1'],
      ['v7-2','m20','cyber',4,'2025-11-20 10:06','d1'],

      // u8 - warning in Dec, reoffence 11 days later (Q3)
      ['v8-1','m21','self_harm',3,'2025-12-01 10:06','d1'],
      ['v8-2','m22','self_harm',3,'2025-12-12 10:06','d1'],

      // u9 - GRAIN TRAP: 2 warnings, only second has reoffence
      ['v9-1','m23','cyber',4,'2025-12-15 10:06','d1'],
      ['v9-2','m24','cyber',4,'2026-02-01 10:06','d1'],
      ['v9-3','m25','cyber',4,'2026-02-05 10:06','d1'],

      // u10 - FAN-OUT TRAP: 1 warning, 3 reoffences in 14d
      ['v10-1','m26','cbrn',4,'2026-01-10 10:06','d1'],
      ['v10-2','m27','cbrn',3,'2026-01-12 10:06','d1'],
      ['v10-3','m28','cbrn',3,'2026-01-15 10:06','d1'],
      ['v10-4','m29','cbrn',3,'2026-01-20 10:06','d1'],

      // u11 - Low severity violations in last 7d (should be EXCLUDED by sev>=4 filter)
      ['v11-1','m30','cyber',2,'2026-04-05 10:06','d2'],        // Q1: last 7d, sev2 - EXCLUDED
      ['v11-2','m31','harassment',3,'2026-04-06 11:06','d2'],   // Q1: last 7d, sev3 - EXCLUDED

      // u12 - Low severity cbrn in last 7d (should be EXCLUDED)
      ['v12-1','m32','cbrn',2,'2026-04-07 14:06','d2'],         // Q1: last 7d, sev2 - EXCLUDED

      // u13 - Mix of low and high severity in last 7d
      ['v13-1','m33','cyber',3,'2026-04-08 16:06','d2'],        // Q1: last 7d, sev3 - EXCLUDED
      ['v13-2','m34','harassment',5,'2026-04-09 09:06','d2']    // Q1: last 7d, sev5 - INCLUDED
    ];

    const violStmt = db.prepare(
      'INSERT INTO policy_violations (violation_id, message_id, policy_category, severity, detected_at, detector_version) VALUES (?, ?, ?, ?, ?, ?)'
    );
    violations.forEach(v => violStmt.run(v));
    violStmt.free();

    // Enforcement Actions
    const actions = [
      ['a1','u1','warning','2026-01-20 09:00','v1-1'],  // cyber, no reoffence
      ['a2','u1','warning','2026-03-03 09:00','v1-4'],  // cbrn, no reoffence
      ['a3','u2','warning','2026-02-17 09:00','v2-1'],  // cyber, no reoffence
      ['a4','u3','warning','2026-03-01 12:00','v3-1'],  // harassment, reoffence on Mar 10
      ['a5','u7','warning','2025-11-15 11:00','v7-1'],  // cyber, reoffence on Nov 20
      ['a6','u8','warning','2025-12-01 11:00','v8-1'],  // self_harm, reoffence on Dec 12
      ['a7','u9','warning','2025-12-15 11:00','v9-1'],  // cyber, no reoffence
      ['a8','u9','warning','2026-02-01 11:00','v9-2'],  // cyber, reoffence on Feb 5
      ['a9','u10','warning','2026-01-10 11:00','v10-1'] // cbrn, 3 reoffences
    ];

    const actionStmt = db.prepare(
      'INSERT INTO enforcement_actions (action_id, user_id, action_type, created_at, triggering_violation_id) VALUES (?, ?, ?, ?, ?)'
    );
    actions.forEach(a => actionStmt.run(a));
    actionStmt.free();
  },

  questions: [
    {
      id: 1,
      difficulty: 'Warm-up',
      timeLimit: 600, // 10 minutes
      question: `For the past 7 days, return the number of distinct users who had at least one severity-4-or-higher policy violation, broken down by policy_category. Sort by the count descending, then by policy_category ascending.

Expected columns: policy_category, num_users.

Important: Only include violations with severity >= 4. There are lower-severity violations in the dataset that should be excluded.

Note: "now" is pinned at 2026-04-10 12:00:00 for deterministic results. Use datetime('2026-04-10 12:00:00', '-7 days') for the date filter.

Expected result (with severity >= 4):
- cyber: 3 users (u1, u2, u4)
- harassment: 2 users (u3, u13)
- cbrn: 1 user (u1)

If severity filter is omitted, results would be:
- cyber: 5 users (u1, u2, u4, u11, u13)
- harassment: 3 users (u3, u11, u13)
- cbrn: 2 users (u1, u12)`,
      referenceSQL: `
        SELECT pv.policy_category, COUNT(DISTINCT c.user_id) AS num_users
        FROM policy_violations pv
        JOIN messages m ON m.message_id = pv.message_id
        JOIN conversations c ON c.conversation_id = m.conversation_id
        WHERE pv.detected_at >= datetime('2026-04-10 12:00:00', '-7 days')
          AND pv.severity >= 4
        GROUP BY pv.policy_category
        ORDER BY num_users DESC, pv.policy_category ASC
      `,
      solutionSQL: `SELECT pv.policy_category, COUNT(DISTINCT c.user_id) AS num_users
FROM policy_violations pv
JOIN messages m ON m.message_id = pv.message_id
JOIN conversations c ON c.conversation_id = m.conversation_id
WHERE pv.detected_at >= datetime('2026-04-10 12:00:00', '-7 days')
  AND pv.severity >= 4
GROUP BY pv.policy_category
ORDER BY num_users DESC, pv.policy_category ASC`,
      expectedColumns: ['policy_category', 'num_users']
    },
    {
      id: 2,
      difficulty: 'Medium',
      timeLimit: 1200, // 20 minutes
      question: `Find repeat offenders: users who had violations in 3 or more distinct calendar weeks over the last 90 days, where at least one of those weeks contained a severity ≥ 3 violation.

For each such user return: user_id, num_weeks (distinct weeks active), num_violations (total in window), top_category (most common policy_category, ties broken alphabetically). Order by num_violations desc, then user_id asc.

Hint: Use strftime('%Y-%W', detected_at) to extract calendar week.`,
      referenceSQL: `
        WITH violation_weeks AS (
          SELECT
            c.user_id,
            pv.violation_id,
            pv.policy_category,
            pv.severity,
            strftime('%Y-%W', pv.detected_at) AS detected_week
          FROM policy_violations pv
          JOIN messages m ON m.message_id = pv.message_id
          JOIN conversations c ON c.conversation_id = m.conversation_id
          WHERE pv.detected_at >= datetime('2026-04-10 12:00:00', '-90 days')
        ),
        affected_users AS (
          SELECT
            user_id,
            COUNT(DISTINCT detected_week) AS num_weeks,
            COUNT(*) AS num_violations,
            MAX(severity) AS max_severity
          FROM violation_weeks
          GROUP BY user_id
          HAVING COUNT(DISTINCT detected_week) >= 3
             AND MAX(severity) >= 3
        ),
        category_ranking AS (
          SELECT
            user_id,
            policy_category,
            ROW_NUMBER() OVER (
              PARTITION BY user_id
              ORDER BY COUNT(*) DESC, policy_category ASC
            ) AS rn
          FROM violation_weeks
          GROUP BY user_id, policy_category
        )
        SELECT
          u.user_id,
          u.num_weeks,
          u.num_violations,
          cr.policy_category AS top_category
        FROM affected_users u
        JOIN category_ranking cr ON cr.user_id = u.user_id AND cr.rn = 1
        ORDER BY u.num_violations DESC, u.user_id ASC
      `,
      solutionSQL: `WITH violation_weeks AS (
  SELECT
    c.user_id,
    pv.policy_category,
    pv.severity,
    strftime('%Y-%W', pv.detected_at) AS detected_week
  FROM policy_violations pv
  JOIN messages m ON m.message_id = pv.message_id
  JOIN conversations c ON c.conversation_id = m.conversation_id
  WHERE pv.detected_at >= datetime('2026-04-10 12:00:00', '-90 days')
),
affected_users AS (
  SELECT
    user_id,
    COUNT(DISTINCT detected_week) AS num_weeks,
    COUNT(*) AS num_violations,
    MAX(severity) AS max_severity
  FROM violation_weeks
  GROUP BY user_id
  HAVING COUNT(DISTINCT detected_week) >= 3 AND MAX(severity) >= 3
),
category_ranking AS (
  SELECT
    user_id,
    policy_category,
    ROW_NUMBER() OVER (
      PARTITION BY user_id
      ORDER BY COUNT(*) DESC, policy_category ASC
    ) AS rn
  FROM violation_weeks
  GROUP BY user_id, policy_category
)
SELECT u.user_id, u.num_weeks, u.num_violations, cr.policy_category AS top_category
FROM affected_users u
JOIN category_ranking cr ON cr.user_id = u.user_id AND cr.rn = 1
ORDER BY u.num_violations DESC, u.user_id ASC`,
      expectedColumns: ['user_id', 'num_weeks', 'num_violations', 'top_category']
    },
    {
      id: 3,
      difficulty: 'Hard',
      timeLimit: 1800, // 30 minutes
      question: `For every 'warning' enforcement action issued in the last 180 days, determine whether the user committed another severity ≥ 3 violation within 14 days after the warning (strictly after, inclusive of day 14). Then compute recidivism rate bucketed by the policy_category of the violation that triggered the warning.

Return: trigger_category, warnings_issued, reoffended_within_14d, recidivism_rate (rounded to 3 decimals). Order by rate desc, then category asc.

Important: A user may have multiple warnings. Match each warning to reoffences by that specific user, not by user_id alone. Use DISTINCT when counting reoffences per warning to avoid fan-out issues.`,
      referenceSQL: `
        WITH warnings AS (
          SELECT
            ea.action_id,
            ea.user_id,
            ea.created_at AS warned_at,
            pv.policy_category AS trigger_category
          FROM enforcement_actions ea
          JOIN policy_violations pv ON pv.violation_id = ea.triggering_violation_id
          WHERE ea.action_type = 'warning'
            AND ea.created_at >= datetime('2026-04-10 12:00:00', '-180 days')
        ),
        user_violations AS (
          SELECT c.user_id, pv.detected_at, pv.severity
          FROM policy_violations pv
          JOIN messages m ON m.message_id = pv.message_id
          JOIN conversations c ON c.conversation_id = m.conversation_id
        ),
        flagged AS (
          SELECT
            w.action_id,
            w.trigger_category,
            MAX(CASE
              WHEN uv.detected_at > w.warned_at
               AND uv.detected_at <= datetime(w.warned_at, '+14 days')
               AND uv.severity >= 3
              THEN 1 ELSE 0
            END) AS reoffended
          FROM warnings w
          LEFT JOIN user_violations uv ON uv.user_id = w.user_id
          GROUP BY w.action_id, w.trigger_category
        )
        SELECT
          trigger_category,
          COUNT(*) AS warnings_issued,
          COALESCE(SUM(reoffended), 0) AS reoffended_within_14d,
          ROUND(CAST(COALESCE(SUM(reoffended), 0) AS REAL) / COUNT(*), 3) AS recidivism_rate
        FROM flagged
        GROUP BY trigger_category
        ORDER BY recidivism_rate DESC, trigger_category ASC
      `,
      solutionSQL: `WITH warnings AS (
  SELECT ea.action_id, ea.user_id, ea.created_at AS warned_at,
         pv.policy_category AS trigger_category
  FROM enforcement_actions ea
  JOIN policy_violations pv ON pv.violation_id = ea.triggering_violation_id
  WHERE ea.action_type = 'warning'
    AND ea.created_at >= datetime('2026-04-10 12:00:00', '-180 days')
),
user_violations AS (
  SELECT c.user_id, pv.detected_at, pv.severity
  FROM policy_violations pv
  JOIN messages m ON m.message_id = pv.message_id
  JOIN conversations c ON c.conversation_id = m.conversation_id
),
flagged AS (
  SELECT w.action_id, w.trigger_category,
    MAX(CASE
      WHEN uv.detected_at > w.warned_at
       AND uv.detected_at <= datetime(w.warned_at, '+14 days')
       AND uv.severity >= 3
      THEN 1 ELSE 0
    END) AS reoffended
  FROM warnings w
  LEFT JOIN user_violations uv ON uv.user_id = w.user_id
  GROUP BY w.action_id, w.trigger_category
)
SELECT trigger_category,
       COUNT(*) AS warnings_issued,
       COALESCE(SUM(reoffended), 0) AS reoffended_within_14d,
       ROUND(CAST(COALESCE(SUM(reoffended), 0) AS REAL) / COUNT(*), 3) AS recidivism_rate
FROM flagged
GROUP BY trigger_category
ORDER BY recidivism_rate DESC, trigger_category ASC`,
      expectedColumns: ['trigger_category', 'warnings_issued', 'reoffended_within_14d', 'recidivism_rate']
    }
  ]
};

export default integrityTest;
